
import React from "react";
import { useRole } from "@/hooks/useRole";
import { Loader2 } from "lucide-react";
import { AccessDenied } from "@/components/admin/games/AccessDenied";
import { MentoriasPageHeader } from "@/components/admin/mentorias/MentoriasPageHeader";
import { MentoriaSearchBar } from "@/components/admin/mentorias/MentoriaSearchBar";
import { MentoriasLoadingState } from "@/components/admin/mentorias/MentoriasLoadingState";
import { MentoriasList } from "@/components/admin/mentorias/MentoriasList";
import { MentoriaDetailsDialog } from "@/components/admin/mentorias/MentoriaDetailsDialog";
import { MentoriasStatusTabs } from "@/components/admin/mentorias/MentoriasStatusTabs";
import { useMentoriasAdmin } from "@/hooks/useMentoriasAdmin";

const MentoriasAdmin = () => {
  const { role, loading: roleLoading } = useRole();
  const {
    mentorias,
    allMentorias,
    loading,
    isDetailsDialogOpen,
    setIsDetailsDialogOpen,
    currentMentoria,
    searchTerm,
    setSearchTerm,
    statusFilter,
    setStatusFilter,
    openEditDialog,
    openDetailsDialog,
    toggleMentoriaStatus
  } = useMentoriasAdmin();

  if (roleLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-[#0f141c] pt-16">
        <Loader2 className="h-12 w-12 text-[#00B6F0] animate-spin" />
      </div>
    );
  }

  if (role !== "admin") {
    return <AccessDenied />;
  }
  
  // Count active and inactive mentorias
  const activeMentorias = allMentorias.filter(m => m.is_active).length;
  const inactiveMentorias = allMentorias.filter(m => !m.is_active).length;

  return (
    <div className="bg-[#0f141c] min-h-screen pt-16 p-8">
      <div className="max-w-6xl mx-auto">
        <MentoriasPageHeader 
          totalMentorias={allMentorias.length} 
          activeMentorias={activeMentorias}
          inactiveMentorias={inactiveMentorias}
        />

        <div className="mb-6 space-y-4">
          <MentoriasStatusTabs 
            statusFilter={statusFilter}
            setStatusFilter={setStatusFilter}
            activeCount={activeMentorias}
            inactiveCount={inactiveMentorias}
          />
          <MentoriaSearchBar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
        </div>

        {loading ? (
          <MentoriasLoadingState />
        ) : (
          <MentoriasList 
            mentorias={mentorias} 
            searchTerm={searchTerm}
            onEdit={openEditDialog} 
            onViewDetails={openDetailsDialog}
            onToggleStatus={toggleMentoriaStatus}
          />
        )}
        
        <MentoriaDetailsDialog 
          isOpen={isDetailsDialogOpen}
          onClose={() => setIsDetailsDialogOpen(false)}
          mentoria={currentMentoria}
        />
      </div>
    </div>
  );
};

export default MentoriasAdmin;
